import {
    executeFilePutMethod, executeJsonGetMethod, executeJsonPostMethod, executeJsonPutMethod
} from '../api/rest/restApiUtils'

export function saveOrUpdateTree(file: any, name: string, status: string) {
    let formData = new FormData()
    formData.append('file', file)
    return executeFilePutMethod(`/v1/trees?name=${name}&status=${status}`, formData).then((resp) => {
        return resp.json()
    })
}

export function getAll() {
    return executeJsonGetMethod(`/v1/trees`).then((resp) => {
        return  resp.data.content;
    })
}

export function getEnabled() {
    return executeJsonGetMethod(`/v1/trees/enabled`).then((resp) => {
        return resp.data.content;
    })
}